import React from 'react';
import { Modal } from '@mantine/core';
import { WOLT_DIRECTION_LABELS, WOLT_KIND_LABELS, WOLT_STATUS_LABELS } from '../monitoring-page.constants';
import { formatDateTime } from '../monitoring-page.utils';
import type { UseMonitoringPage } from '../useMonitoringPage';
import classes from '../monitoring-page.module.scss';

type WoltCallLogDetailModalProps = Pick<UseMonitoringPage, 'selectedWoltLog' | 'closeWoltDetail'>;

const prettyJson = (value: string | null): string => {
  if (!value) {
    return '—';
  }
  try {
    return JSON.stringify(JSON.parse(value), null, 2);
  } catch {
    return value;
  }
};

export const WoltCallLogDetailModal: React.FC<WoltCallLogDetailModalProps> = ({
  selectedWoltLog,
  closeWoltDetail,
}) => {
  const row = selectedWoltLog;

  const fields: { label: string; value: string }[] = row
    ? [
        { label: 'תאריך ושעה', value: formatDateTime(row.createdAt) },
        { label: 'עסק', value: row.companyName ?? row.tenantId ?? '-' },
        { label: 'כיוון', value: WOLT_DIRECTION_LABELS[row.direction] ?? row.direction },
        { label: 'סוג', value: WOLT_KIND_LABELS[row.kind] ?? row.kind },
        { label: 'סטטוס', value: WOLT_STATUS_LABELS[row.status] ?? row.status },
        { label: 'קוד HTTP', value: row.httpStatus != null ? String(row.httpStatus) : '-' },
        { label: 'זמן תגובה', value: row.latencyMs != null ? `${row.latencyMs} ms` : '-' },
        { label: 'הזמנת וולט', value: row.woltOrderId ?? '-' },
      ]
    : [];

  return (
    <Modal
      opened={row != null}
      onClose={closeWoltDetail}
      title={row ? `${WOLT_KIND_LABELS[row.kind] ?? row.kind} · ${WOLT_STATUS_LABELS[row.status] ?? row.status}` : ''}
      centered
      size="xl"
      closeButtonProps={{ 'data-testid': 'monitoring-wolt-detail-close' } as Record<string, string>}
    >
      {row && (
        <div className={classes.errorDetail} data-testid="monitoring-wolt-detail">
          <div className={classes.detailsSection}>
            {fields.map((field) => (
              <div key={field.label} className={classes.detailField}>
                <span className={classes.detailLabel}>{field.label}</span>
                <span className={classes.detailValue}>{field.value}</span>
              </div>
            ))}
          </div>

          {row.errorMessage && (
            <>
              <div className={classes.sectionTitle}>{'שגיאה'}</div>
              <pre className={classes.errorTrace}>{row.errorMessage}</pre>
            </>
          )}

          <div className={classes.sectionTitle}>{'בקשה'}</div>
          <pre className={classes.errorTrace}>{prettyJson(row.requestPayload)}</pre>

          <div className={classes.sectionTitle}>{'תגובה'}</div>
          <pre className={classes.errorTrace}>{prettyJson(row.responseBody)}</pre>
        </div>
      )}
    </Modal>
  );
};
